export default __webpack_public_path__ + "static/media/cv-tags.9f7115f7.gif";